import clsx from 'clsx'
import type { PropsWithChildren } from 'react'

import {
  FvButton,
  type FvButtonProps,
  FvLinkButton,
  type FvLinkButtonProps,
  isFvLinkButtonProps,
} from '@fv/client-components'
import type { PropsWithClassName } from '@fv/client-types'

import { DividedContent } from './DividedContent'
import { ShipperTooltip } from './ShipperTooltip'

export const ActionList = ({
  children,
  className,
}: PropsWithChildren<PropsWithClassName>) => {
  return (
    <DividedContent
      className={clsx('[&>*]:py-1 [&>button+button]:ml-0', className)}
    >
      {children}
    </DividedContent>
  )
}

type Props = (FvButtonProps | FvLinkButtonProps) & {
  tooltip?: string
}
export const ActionListItem = (props: Props) => {
  return isFvLinkButtonProps(props) ? (
    <ShipperTooltip label={props.tooltip}>
      <FvLinkButton {...props} className={`${props.className}`} />
    </ShipperTooltip>
  ) : (
    <ShipperTooltip label={props.tooltip}>
      <FvButton {...props} className={`${props.className}`} />
    </ShipperTooltip>
  )
}
